import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';

export function AuthLayout() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (isAuthenticated && user) {
    const redirectTo = user.role === 'client' ? '/dashboard' : '/start';
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-primary">WeTicket</h1>
          <p className="mt-2 text-muted-foreground">Task Management System</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
